import { PrecomputedEvaluationsInterface } from '@statsig/js-client';
import { ENVIRONMENTS } from 'src/constants/environment';
import { CONFIG } from 'src/constants/config';

/**
 * Log a Statsig event only when running in production.
 */
export const logStatsigEvent = (
  client: PrecomputedEvaluationsInterface,
  eventName: string,
  value?: string | number,
  metadata?: Record<string, string>,
): void => {
  if (CONFIG.ENVIRONMENT !== ENVIRONMENTS.production) {
    return;
  }

  client.logEvent(eventName, value, metadata);
};
